
(function () {
  const ticker = document.currentScript.parentElement;
  let speed = parseInt(ticker.getAttribute('data-speed')) * 1000
  const breakpoint = ticker.getAttribute('data-breakpoint')

  if (isNaN(speed)) {
    speed = 8000
  }

  if (window.innerWidth < breakpoint) {
    let swiper = new Swiper(ticker, {
      spaceBetween: 0,
      centeredSlides: true,
      speed: speed,
      autoplay: {
        delay: 1,
      },
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
      disableOnInteraction: true
    });
  }
})();





